import { downloadUrl } from '../actions/download_url'
import { toggleItemLoading } from '../render/item_loading'

function itemHandler(item: Element) {
    const closestParent = item.closest('[role="listitem"]')
    if (!closestParent) {
        console.warn('[ScriptLogic] - No closest parent found for item:', item)
        return
    }

    const closestEmbed = closestParent.querySelector('[download-item="image"]')
    if (!closestEmbed) {
        console.warn('[ScriptLogic] - No embed found for item:', item)
        return
    }

    const name = closestEmbed.getAttribute('name') || 'Unnamed Item - ARKEN'
    const imageSrc = closestEmbed.getAttribute('imgsrc')
    const fallbackSrc = closestEmbed.getAttribute('fallback')
    toggleItemLoading(item, true)

    if (imageSrc) {
        downloadUrl(imageSrc, name, item)
    } else if (fallbackSrc) {
        downloadUrl(fallbackSrc, name, item)
    } else {
        console.warn('[ScriptLogic] - No image source found for item:', item)
        toggleItemLoading(item, false)
    }
}

export { itemHandler }
